@if (
  {
    expanded: (expanded$ | async)!,
    items: (items$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'dauer'"
    [label]="'Dauer'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    @if (context.expanded) {
      <fieldset id="dauerFacette" class="now-input-group">
        <legend class="sr-only">Dauer</legend>
        <div class="now-radio-group" role="radiogroup">
          @for (dauer of context.items; track trackById(index, dauer); let index = $index) {
            <div class="form-check">
              <input
                id="dauerFacette-option-{{ index }}"
                type="radio"
                name="dauerFacette"
                [disabled]="!dauer.selected && !dauer.active"
                [value]="index"
                (click)="updateSelectedIds(dauer.key)"
                [checked]="dauer.selected"
              /><label for="dauerFacette-option-{{ index }}">{{ dauer.label }}</label>
            </div>
          }
        </div>
      </fieldset>
    }
  </now-wbsuche-lib-basis-facette>
}
